import { useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import App from 'modules/App';
import Account from 'modules/Account';
import CloudDrive from 'modules/CloudDrive';
import { useAction, useProgressSuccess } from 'hooks';
import { AppContext } from 'context';
import * as selectors from '../../selectors';
const usePatientSetupEffects = (externalReturnUrl)=>{
    const patientProfile = useSelector(Account.selectors.patientProfile);
    const isInProgress = useSelector(selectors.isPatientSetupProgress);
    const hasError = useSelector(selectors.hasPatientSetupErrors);
    const { externalRedirect } = useContext(AppContext);
    const goToAid = useAction(App.actions.goToAid);
    const authorizeCloudDrive = useAction(CloudDrive.actions.authorize);
    const redirect = ()=>{
        const decodedUrl = decodeURIComponent(externalReturnUrl);
        if (decodedUrl) {
            externalRedirect(decodedUrl);
        } else {
            goToAid('mobile/host', null);
        }
    };
    useEffect(()=>{
        if (!patientProfile || !patientProfile.encryptedExchangeToken) {
            authorizeCloudDrive('CentralStorage', 'pwd');
        } else if (patientProfile && patientProfile.encryptedExchangeToken) {
            redirect();
        }
    }, []);
    useProgressSuccess(isInProgress, hasError, redirect);
};
export default usePatientSetupEffects;
